export enum ExternalOrderStateEnum {
  RECEIVED = 'received',
  PROCESSING = 'processing',
  PROCESSED = 'processed',
  ERROR = 'error',
  CANCELLED = 'cancelled',
}

export interface ExternalOrderProvider {
  id: number;
  name: string;
  provider_type: string;
}

export interface ExternalOrderLine {
  item_description: string;
  quantity: number;
}

export interface ExternalOrderShippingAddress {
  id: number;
  name: string;
  street: string;
  country: string;
  city: string;
  region: string | null;
  postcode: string;
  phone: string;
  comments: string;
}

export interface ExternalOrderModel {
  id: number;
  number: string;
  status: ExternalOrderStateEnum;
  status_display: string;
  date: string | null;
  shipping_address: ExternalOrderShippingAddress;
  provider: ExternalOrderProvider;
  total_lines: number;
  lines: ExternalOrderLine[];
  email?: string | null;
  shipment_number: string | null;
  shipment_date: string | null;
  label_urls: string[];
  created_at: string;
  updated_at: string;
}
